var _rect, _rect2, _rect3, _rect4, _rect5, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMianji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.40625,
    y: 2.84375,
    width: 10.125,
    height: 10.25,
    fill: "white",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 2.875,
    height: 2.875,
    fill: "white",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11.625,
    width: 2.875,
    height: 2.875,
    fill: "white",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0625,
    y: 1.5,
    width: 2.875,
    height: 2.875,
    fill: "white",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0625,
    y: 11.625,
    width: 2.875,
    height: 2.875,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59473 9.5H8.80859V7.95947C8.80859 7.54606 8.65804 7.33936 8.35693 7.33936C8.21696 7.33936 8.10059 7.40202 8.00781 7.52734C7.91504 7.65267 7.86865 7.80566 7.86865 7.98633V9.5H7.08252V7.93994C7.08252 7.53955 6.93359 7.33936 6.63574 7.33936C6.48763 7.33936 6.36882 7.39958 6.2793 7.52002C6.19141 7.63883 6.14746 7.79671 6.14746 7.99365V9.5H5.35889V6.7998H6.14746V7.22217H6.15723C6.25163 7.06755 6.37695 6.94792 6.5332 6.86328C6.68945 6.77702 6.85384 6.73389 7.02637 6.73389C7.4056 6.73389 7.6652 6.90397 7.80518 7.24414C8.01351 6.90397 8.31624 6.73389 8.71338 6.73389C9.30094 6.73389 9.59473 7.09684 9.59473 7.82275V9.5ZM11.7969 7.95947H10.2173V7.55908L10.8691 6.94141C11.0107 6.80794 11.0986 6.70785 11.1328 6.64111C11.167 6.57438 11.1841 6.4987 11.1841 6.41406C11.1841 6.33594 11.158 6.27246 11.106 6.22363C11.0555 6.17318 10.9871 6.14795 10.9009 6.14795C10.7235 6.14795 10.5371 6.23828 10.3418 6.41895V5.87207C10.542 5.73535 10.7601 5.66699 10.9961 5.66699C11.2305 5.66699 11.4168 5.72721 11.5552 5.84766C11.6951 5.96647 11.7651 6.13086 11.7651 6.34082C11.7651 6.50033 11.7277 6.63704 11.6528 6.75098C11.5796 6.86491 11.4266 7.02604 11.1938 7.23438L10.9009 7.49805V7.50781H11.7969V7.95947Z",
    fill: "#1A4ED2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMianji);
export default __webpack_public_path__ + "static/media/mianji.da631e5b97f92512b973fc7eddd434d9.svg";
export { ForwardRef as ReactComponent };